import type { Session } from './api.js';

/**
 * Une session est utilisable tant qu'elle est authentifiée, non expirée et
 * porteuse d'un jeton anti-CSRF. Les trois conditions comptent : une session
 * authentifiée sans jeton CSRF ne peut rien modifier, et l'interface doit le
 * traiter comme une déconnexion plutôt que d'enchaîner les 403.
 */
export function isUsable(session: Session | null, now: Date = new Date()): boolean {
  if (!session?.authenticated) return false;
  if (!session.csrfToken) return false;
  if (!session.expiresAt) return true;
  const expiry = Date.parse(session.expiresAt);
  if (Number.isNaN(expiry)) return false;
  return expiry > now.getTime();
}

/** Nombre de minutes restantes, arrondi vers le bas. Négatif si déjà expirée. */
export function minutesRemaining(session: Session | null, now: Date = new Date()): number | null {
  if (!session?.expiresAt) return null;
  const expiry = Date.parse(session.expiresAt);
  if (Number.isNaN(expiry)) return null;
  return Math.floor((expiry - now.getTime()) / 60_000);
}
